__turbopack_context__.v({
  "full-width-button": "reviews-modal-module-scss-module__J8xqXa__full-width-button",
  "ratings-filter-container": "reviews-modal-module-scss-module__J8xqXa__ratings-filter-container",
  "review": "reviews-modal-module-scss-module__J8xqXa__review",
  "reviews-controls": "reviews-modal-module-scss-module__J8xqXa__reviews-controls",
  "reviews-list": "reviews-modal-module-scss-module__J8xqXa__reviews-list",
  "reviews-list-item": "reviews-modal-module-scss-module__J8xqXa__reviews-list-item",
  "reviews-list-section": "reviews-modal-module-scss-module__J8xqXa__reviews-list-section",
  "reviews-list-skeleton": "reviews-modal-module-scss-module__J8xqXa__reviews-list-skeleton",
  "reviews-modal": "reviews-modal-module-scss-module__J8xqXa__reviews-modal",
  "reviews-modal-content": "reviews-modal-module-scss-module__J8xqXa__reviews-modal-content",
  "reviews-two-column-layout": "reviews-modal-module-scss-module__J8xqXa__reviews-two-column-layout",
  "search-submit-button": "reviews-modal-module-scss-module__J8xqXa__search-submit-button",
  "show-more-reviews-button": "reviews-modal-module-scss-module__J8xqXa__show-more-reviews-button",
});
